export function PageSoft({ ...props }) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="vuesax/linear/document-text">
        <g id="document-text">
          <path
            id="Union"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.9167 2.41669H7.50008C5.49072 2.41669 4.27928 2.82315 3.55124 3.55118C2.82321 4.27922 2.41675 5.49066 2.41675 7.50002V12.5C2.41675 14.5094 2.82321 15.7208 3.55124 16.4489C4.27928 17.1769 5.49072 17.5834 7.50008 17.5834H12.5001C14.5094 17.5834 15.7209 17.1769 16.4489 16.4489C17.177 15.7208 17.5834 14.5094 17.5834 12.5V9.08335H15.0001C13.7085 9.08335 12.6088 8.87777 11.8656 8.13452C11.1223 7.39126 10.9167 6.29157 10.9167 5.00002V2.41669ZM18.8637 7.80302C18.8772 7.81643 18.89 7.83026 18.9022 7.84447C19.0127 7.97297 19.0746 8.13298 19.0826 8.29735C19.0832 8.31131 19.0835 8.3253 19.0834 8.3393M19.0834 8.3393V12.5C19.0834 14.6573 18.6565 16.3625 17.5096 17.5095C16.3626 18.6565 14.6574 19.0834 12.5001 19.0834H7.50008C5.34278 19.0834 3.63755 18.6565 2.49058 17.5095C1.34362 16.3625 0.916748 14.6573 0.916748 12.5V7.50002C0.916748 5.34272 1.34362 3.63749 2.49058 2.49052C3.63755 1.34355 5.34278 0.916687 7.50008 0.916687H11.6608H11.6667C11.6788 0.916687 11.6908 0.916974 11.7027 0.917538M12.1976 1.1369L18.8637 7.80302L12.1976 1.1369ZM12.4167 5.00002V3.47735L16.5228 7.58335H15.0001C13.7916 7.58335 13.2247 7.37227 12.9262 7.07386C12.6278 6.77544 12.4167 6.20847 12.4167 5.00002Z"
            fill="#737373"
          />
          <path
            id="Line"
            d="M5.83325 10.8333H10.8333"
            stroke="#737373"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Line_2"
            d="M5.83325 14.1667H9.16659"
            stroke="#737373"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
}
